export default class Templates {
	static getTableTemplate() {
		return '[Template]\n' +
			'TemplateVersion = 1.0\n' +
			'TableID = Table-1.0\n' +
			'TemplateName = RetrieveTables\n' +
			'Intent = Retrieve\n' +
			'StructuredData = True\n' +
			'Format = JSON\n' +
			'OrderBy = Input.Name\n' +
			'\n' +
			'[Output]\n' +
			'Name = Input.Name\n' +
			'Id = Input.Id\n' +
			'SupportedOperations = Input.SupportedOperations' +
			'\n' +
			'[Filter]\n' +
			'IsCustom = Equals("False")\n' +
			'[Script]\n' +
			'(function(tde){\n' +
			'	tde.onRow = function(row) {\n' +
			'		var tablesToExclude = [\n' +
			'			"AssetType-1.0","Customer-1.0","Column-1.0",\n' +
			'			"DataType-1.0","ErrorCode-1.0","ExternalKey-1.0",\n' +
			'			"FormTemplate-1.0","InstallType-1.0","MeasurementUnit-1.0",\n' +
			'			"Table-1.0","TimeZone-1.0"\n' +
			'		];\n' +
			'		if (tablesToExclude.indexOf(row.Name) < 0) {\n' +
			'			return [row];\n' +
			'		}\n' +
			'		return [];\n' +
			'	}\n' +
			'})(tde)';
	}

	static calculateBoundary(){
		return '-------------------------' + Math.random().toString().substr(2);
	}

	static formRequest(){
		return Templates.getPostBody('', Templates.getTableTemplate());
	}

	static getPostBody(inputFile, template){
		let boundary = Templates.calculateBoundary();
		return '--' + boundary +
			'\r\nContent-Disposition: form-data; name="template"; filename="uploadedtemporarytemplate"' +
			'\r\nContent-type: text/plain\r\n\r\n' + template + '\r\n' +
			'--' + boundary + '\r\nContent-Disposition: file; name="csvdata"; filename="tdetrans.csv"' +
			'\r\nContent-type: text/plain\r\n\r\n' + inputFile + '\r\n' +
			'--' + boundary + '--\r\n';
	}

	static getColumnTemplate(id){
		let output = '[Template]\n' +
			'TemplateVersion = 1.0\n' +
			'TableID = Column-1.0\n' +
			'TemplateName = RetrieveColumns\n' +
			'Intent = Retrieve\n' +
			'Format = JSON\n' +
			'OrderBy = Input.TableID, Input.Name\n' +
			'\n' +
			'[Output]\n' +
			'TableId = Input.TableId\n' +
			'Name = Input.Name\n' +
			'DataTypeId = Input.DataTypeId\n' +
			'ForeignTableId = Input.ForeignTableId\n' +
			'IsEnumerable = Input.IsEnumerable\n' +
			'IsDiagnostic = Input.IsDiagnostic\n' +
			'IsReadable = Input.IsReadable\n' +
			'IsWriteable = Input.IsWriteable\n' +
			'IsTelogisKey = Input.IsTelogisKey\n' +
			'\n' +
			'[Filter]\n' +
			'IsDiagnostic = Equals("false")\n' +
			'TableID = Equals("' + id + '")';
		return output;
	}

	static getDataTypeTemplate(){
		let output = '[Template]\n' +
			'TemplateVersion = 1.0\n' +
			'TableID = DataType-1.0\n' +
			'TemplateName = RetrieveDataTypes\n' +
			'Intent = Retrieve\n' +
			'Format = JSON\n' +
			'\n' +
			'[Output]\n' +
			'Id = Input.Id\n' +
			'Name = Input.Name\n' +
			'IsMeasurement = Input.IsMeasurement\n' +
			'ReferenceMeasurementUnitId = Input.ReferenceMeasurementUnitId\n' +
			'IsEnum = Input.IsEnum\n' +
			'EnumValues = Input.EnumValues\n' +
			'GenericTypeParameterIds = Input.GenericTypeParameterIds\n' +
			'BaseTypeId = Input.BaseTypeId';
		return output;
	}

	static getUnitTemplate(){
		let output = '[Template]\n' +
			'TemplateVersion = 1.0\n' +
			'TableID = MeasurementUnit-1.0\n' +
			'TemplateName = RetrieveMeasurementUnits\n' +
			'Intent = Retrieve\n' +
			'Format = JSON\n' +
			'\n' +
			'[Output]\n' +
			'DataTypeId = Input.DataTypeId\n' +
			'Name = Input.Name\n' +
			'Abbreviation = Input.Abbreviation\n' +
			'Scale = Input.Scale\n' +
			'Offset = Input.Offset\n' +
			'Id = Input.Id';
		return output;
	}

	static getTimeZonesTemplate(){
		let output = '[Template]\n' +
			'TemplateVersion = 1.0\n' +
			'TableID = TimeZone-1.0\n' +
			'TableName = TimeZoneTemplate\n' +
			'Intent = Retrieve\n' +
			'Format = JSON\n' +
			'Commit = True\n' +
			'Script = False\n' +
			'OrderBy = Input.UtcOffset, Input.Abbreviation\n' +
			'\n' +
			'[Output]\n' +
			'Name = Input.Name\n' +
			'Abbreviation = Input.Abbreviation\n' +
			'UtcOffset = Input.UtcOffset\n' +
			'Display =  "(UTC " || Input.UtcOffset || ") " || Input.Abbreviation || " - " || Input.Name';
		return output
	}
}